import axios from 'axios'
import { useAuth } from '@eenvoud/eenvauth'

export const IDLE_LIMIT_MS = 4 * 60 * 60 * 1000 // 4 hours

const STORAGE_KEY = 'last_activity_at'
const CHECK_INTERVAL_MS = 60 * 1000
const WRITE_THROTTLE_MS = 30 * 1000
const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000
const ACTIVITY_EVENTS = ['click', 'keydown', 'touchstart', 'mousemove', 'scroll']

let lastWrite = 0
let lastHeartbeat = 0

export function recordActivity () {
  const now = Date.now()
  if (now - lastWrite >= WRITE_THROTTLE_MS) {
    lastWrite = now
    localStorage.setItem(STORAGE_KEY, String(now))
  }
  sendHeartbeat(now)
}

// Confirms to the API that a real user is still interacting, independent of
// whatever business API calls they may or may not be making (e.g. someone
// filling in a long form for a while before hitting save) - otherwise the
// server-side idle check would only ever see the eventual save request and
// could reject it as coming from a stale/idle session.
function sendHeartbeat (now) {
  if (now - lastHeartbeat < HEARTBEAT_INTERVAL_MS) return

  const auth = useAuth()
  if (!auth.getToken()) return

  lastHeartbeat = now
  axios.post('/heartbeat').catch(() => {})
}

export function getIdleDuration () {
  const lastActivity = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10)
  if (!lastActivity) return 0
  return Date.now() - lastActivity
}

export async function enforceIdleLogout () {
  const auth = useAuth()

  if (!auth.getToken() || getIdleDuration() < IDLE_LIMIT_MS) {
    return false
  }

  try {
    await auth.logout()
  } catch (e) {
    // Token is cleared locally regardless of whether the logout request succeeds
  }

  return true
}

export function startIdleLogoutWatcher (router) {
  recordActivity()

  ACTIVITY_EVENTS.forEach(event => {
    window.addEventListener(event, recordActivity, { passive: true })
  })

  const checkAndRedirect = async () => {
    const loggedOut = await enforceIdleLogout()
    if (loggedOut && router.currentRoute.value.name !== 'Login') {
      router.push({ name: 'Login' })
    }
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      sendHeartbeat(Date.now())
      checkAndRedirect()
    }
  })

  window.setInterval(checkAndRedirect, CHECK_INTERVAL_MS)
}
